import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogManagerService } from '../../services/dialog-manager.service';
import { TooltipModule } from 'primeng/tooltip';
import { user } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-activity-panel-small',
  standalone: true,
  imports: [TooltipModule, CommonModule],
  templateUrl: './activity-panel-small.component.html',
  styleUrl: './activity-panel-small.component.scss',
})
export class ActivityPanelSmallComponent {
  userId: number;
  userRole: number;
  userFullname: string;

  permissions: string[];

  accessLevel = environment.accessLevel;

  constructor(
    private authService: AuthService,
    private dialogManager: DialogManagerService,
  ) {}

  @Input() selectedUser: user | undefined = undefined;
  ngOnInit(): void {
    this.userRole = this.authService.getUserRole();
    this.userId = this.authService.getCurrentUserId();
    this.userFullname = this.authService.getUserName();
    this.permissions = this.authService.getUserPermissions();
  }
  //#region BERATUNG

  showAddConsultationDialog(): void {
    this.dialogManager.openConsultationDialog({ user: this.selectedUser });
  }

  //#endregion

  //#region EMAIL

  showSaveEmailDialog(): void {
    this.dialogManager.openEmailDialog({ user: this.selectedUser });
  }

  //#endregion

  //#region Eignungstest Ergebnis

  showAddEignungstestDialog(): void {
    this.dialogManager.openEignungstestDialog({ user: this.selectedUser });
  }

  //#endregion

  //#region Dokumentenupload
  showAddIHKEducationDialog(): void {
    this.dialogManager.openIHKEducationvoucherDialog({
      user: this.selectedUser,
    });
  }
  //#endregion

  //#region LERNERFOLGSKONTROLLE

  showAddLearningDialog(): void {
    this.dialogManager.openLearningDialog({ user: this.selectedUser });
  }

  //#endregion

  //#region ABWESENHEIT

  showAddAbsenceDialog(): void {
    this.dialogManager.openAbsenceDialog({ user: this.selectedUser });
  }

  //#endregion

  //#region KONTAKT

  showAddContactDialog(): void {
    this.dialogManager.openContactDialog({ user: this.selectedUser });
  }

  //#endregion

  //#region Notiz
  showAddNoteDialog(): void {
    this.dialogManager.openNotizDialog({
      user: this.selectedUser,
    });
  }
  //#endregion
}
